export default "__VITE_ASSET__fbb01b7d__"